import React from 'react';
import { Button, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { ThemeProvider, styled } from '@mui/material/styles';
import { BOGLE_REGULAR } from '../../constants/constant';
import { colors } from './../../theme/color-palette';
import { theme } from '../../theme/theme';

const { DARK_GREY } = colors;

export const CustomButton = styled(Button)(() => ({
	color: `${DARK_GREY} !important`,
	fontFeatureSettings: `'clig' off, 'liga' off`,
	padding: 0,
	textTransform: 'none !important',
	backgroundColor: 'transparent',
	'&:hover': {
		backgroundColor: 'transparent',
	},
}));

const CustomHeader = (props) => {
	const { displayName, handleOnClick } = props;

	return (
		<ThemeProvider theme={theme}>
			<CustomButton onClick={() => handleOnClick(displayName)} disableRipple>
				<Typography
					sx={{
						borderBottom: '#909196 2px dotted',
						fontSize: '14px',
						fontStyle: 'normal',
						fontWeight: 700,
						lineHeight: '20px',
						marginLeft: '8px',
						fontFamily: BOGLE_REGULAR,
					}}>
					{displayName}
				</Typography>
			</CustomButton>
		</ThemeProvider>
	);
};

CustomHeader.defaultProps = {
	displayName: '',
};

CustomHeader.propTypes = {
	displayName: PropTypes.string,
	handleOnClick: PropTypes.func,
};

export default CustomHeader;
